
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Comment est-il administré?`}</em></p>
    <p>{`Deux doses sont nécessaires, à trois semaines d’intervalle.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;